export default __webpack_public_path__ + "static/media/promo_06.8b56f444.jpg";